import { f as formatMoney } from './currency-BS0riN3f.js';
import { fetchConfig } from '@utils';

class GiftOption extends HTMLElement {
  static get observedAttributes() {
    return ['tier-price', 'cart-total-price'];
  }

  form = this.querySelector('form');
  amountToSpendTarget = this.querySelector('[data-amount-to-spend]');
  cartItems = document.querySelector('cart-items');
  giftSelector = document.querySelector('gift-selector');

  /**
   * setGiftState
   * @description Set the gift state based on the tier price and the cart total price.
   */
  setGiftState() {
    if (this.form.querySelector('[type="submit"]').hasAttribute('disabled') === true) {
      return;
    }
    // Check the tier price and compare it to the cart total price
    const tierPrice = parseInt(this.getAttribute('tier-price')) || 0;
    const cartTotalPrice = parseInt(this.getAttribute('cart-total-price')) || 1;
    let amountToSpend = 0;

    if (cartTotalPrice >= tierPrice) {
      this.classList.add('active');
    } else {
      amountToSpend = tierPrice - cartTotalPrice;
      this.classList.remove('active');
    }
    this.amountToSpendTarget.textContent = formatMoney(amountToSpend, window.shopMoneyFormat);
  }

  /**
   * handleAddGiftToCart
   * @param {Object} event
   * @returns {void}
   */
  async handleAddGiftToCart(event) {
    event.preventDefault();

    this.giftSelector.classList.add('pointer-events-none');
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    this.cartItems.enableLoading();

    try {
      // First fetch current cart state to double check for gifts
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Use the same gift check logic as cart.js
      const hasGift = cart.items.some((item) => item.properties && '_gift' in item.properties);

      if (hasGift) {
        console.warn('Free gift already in cart');
        // Refresh cart state to ensure everything is in sync
        await this.cartItems.refreshState();
        return;
      }

      // Proceed with adding gift if no gift found
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const sectionsToFetch = [
        ...this.cartItems.getSectionsToRender().map((section) => section.section),
      ];

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      const response = await fetch(`${routes.cart_add_url}`, config);
      const parsedState = await response.json();

      if (response.status === 422) {
        document.getElementById('cart-errors').textContent =
          parsedState.description || window.cartStrings.error;
        return;
      }

      if (!response.ok) throw new Error('Network response was not ok');

      this.cartItems.renderContents(parsedState);
      this.giftSelector.setAttribute('gift', 'in-cart');
      console.log(parsedState);
    } catch (error) {
      console.error(error);
      document.getElementById('cart-errors').textContent =
        window.cartStrings?.error || 'Error adding gift';
    } finally {
      this.giftSelector.classList.remove('pointer-events-none');
      this.cartItems.disableLoading();
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    }
  }

  /**
   * render
   * @description Render the gift option button and amount to spend based on tier pricing.
   */
  render() {
    this.classList.add('pointer-events-none');
    this.setGiftState();
    this.classList.remove('pointer-events-none');
  }

  connectedCallback() {
    this.render();
    document.addEventListener('cart-update', (event) => {
      this.setAttribute('cart-total-price', event?.detail?.total_price || 0);
    });
    this.form.addEventListener('submit', this.handleAddGiftToCart.bind(this));
  }

  attributeChangedCallback() {
    this.render();
  }
}
customElements.define('gift-option', GiftOption);
